import { activationTracking } from "../../../services/tracking";
import {
    GaReconnectButton,
    GaConnectButton,
    GATriggerWithPropertyMapping,
    useActivationGaMappingDetailQuery,
} from "../../ga-connect";
import { gaWidgetDataAutomation } from "../dataAutomationKeys";

type ConnectGaBtnSchema = {
    activationId: string;
};

export const ConnectGaBtn = ({ activationId }: ConnectGaBtnSchema) => {
    const { data, isLoading: isGaMappingLoading } = useActivationGaMappingDetailQuery(activationId, {
        shouldIgnoreResourceNotFoundError: true,
    });

    if (isGaMappingLoading) {
        return null;
    }

    if (data?.state === "Disabled") {
        return (
            <GaReconnectButton
                dataAutomation={gaWidgetDataAutomation.activateGAButton}
                activationId={activationId}
                connectionId={data.connectionId}
                propertyId={data.propertyId}
                streamId={data.streamId}
            />
        );
    }

    const handleOpen = () => {
        activationTracking.home.trackGAConnectButton("connect GA");
    };

    return (
        <GATriggerWithPropertyMapping
            activationId={activationId}
            hasGaMapping={!!data}
            onOpen={handleOpen}
        >
            {({ isLoading, open }) => (
                <GaConnectButton
                    onClick={open}
                    dataAutomation={gaWidgetDataAutomation.connectGAButton}
                    isLoading={isLoading}
                />
            )}
        </GATriggerWithPropertyMapping>
    );
};
